import { createContext } from 'react';

const ProviderConnectionsContext = createContext();

export default ProviderConnectionsContext;
